import { render, staticRenderFns } from "./damageInfo.vue?vue&type=template&id=6236d4ac&scoped=true"
import script from "./damageInfo.vue?vue&type=script&lang=js"
export * from "./damageInfo.vue?vue&type=script&lang=js"
import style0 from "./damageInfo.vue?vue&type=style&index=0&id=6236d4ac&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6236d4ac",
  null
  
)

export default component.exports